import { useEffect } from 'react';
import { AlertContainer } from '../../features/alert/alert-container/alert-container';
import { MetricsHotjar } from '../../features/metrics/metrics-hotjar';
import { MetricsYandex } from '../../features/metrics/metrics-yandex';
import { getDefaultLang, LangEnum } from '../../helpers/lang';
import i18n, { ns } from '../../i18n/i18n';
import { isCurrentHost } from '../../store/api/utils.ts/stand';
import { useCompanyStore } from '../../store/use-company-store';
import { Body } from './body/body';
import s from './manager.module.css';
import { Navigation } from './navigation/navigation';

const defaultLang = localStorage.getItem('i18nextLng') || getDefaultLang() || LangEnum.RU;
import(`../../i18n/${defaultLang}.json`).then((res) =>
  i18n.addResourceBundle(defaultLang, ns, res.default || res),
);

export const Manager = () => {
  const { fetchCompany } = useCompanyStore();

  useEffect(() => {
    fetchCompany();
  }, []);

  return (
    <div className={s.page}>
      {isCurrentHost('prod') && (
        <>
          <MetricsYandex />
          <MetricsHotjar />
        </>
      )}
      <Navigation />
      <Body />
      <AlertContainer />
    </div>
  );
};
